<template>
  <div class="statistics-card">
    <div class="statistics-card-title">
      <span style="float: left; font-weight: bolder">运费占比存疑列表</span>
      <el-button size="mini" @click="exportExcel" type="primary">导出</el-button>
    </div>
    <el-table :data="tableData" class="statistics-table" height="320" @sort-change='sortChange' :loading="loading">
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <div class="title-index">
            <i class="icon"
               :class="{'orange':scope.$index%5==1,'yellow':scope.$index%5==2,'green':scope.$index%5==3,'red':scope.$index%5==4}">{{
                scope.$index + 1
              }}</i>
            <span>{{ scope.row.sparePartsTypeName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="regionName" label="地区" align="center" width="50"></el-table-column>
      <el-table-column prop="trackingNum" label="运单号" width="105" align="center">
        <template slot-scope="scope">
          <span class="click" @click="codeClick(scope.row)">{{ scope.row.trackingNum }}</span>
        </template>
      </el-table-column>
      <el-table-column  prop="proportion" label="运费占比" align="center" width="65">
        <template slot-scope="scope">
          <span class="red"> {{ scope.row.proportion }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalFreight" label="运费金额" align="center" width="65"></el-table-column>
      <el-table-column prop="totalAmount" label="货物金额" align="center" width="65"></el-table-column>
      <el-table-column prop="logisticsCompanyName" label="物流公司" align="center" width="80"></el-table-column>
      <el-table-column prop="" label="操作" align="center" width="50">
        <template slot-scope="scope">
          <el-button class="follow-btn" v-if="common.followUp()" type="danger" size="mini" plain round
                     @click="followUpClick(scope.row)">回访
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <orderDetails ref="orderDetails" :row="activeRow" :type="type"></orderDetails>
  </div>
</template>

<script>
import orderDetails from "./orderDetails.vue"
import {insertLogisticsChecked, logisticsDoubt} from "@/api/statistic";
import {getDate} from "@/common/common";

export default {
  components: {
    orderDetails
  },
  props: ['month', 'type'],
  watch: {
    type() {
      this.getData()
    },
    month() {
      this.query.month = this.month
      this.getData()
    }
  },
  data() {
    return {
      sort: "desc",
      tableData: [],
      query: {
        month: getDate()
      },
      loading: false,
      activeRow: null,
      downloadLoading: false
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    refreshData() {
      this.getData()
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出Excel表格，请耐心等待！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.downloadLoading = true
      let tHeader = [
        "备品类型",
        "地区",
        "运单号",
        "运费占比",
        "运费金额",
        "提货金额",
        "物流公司",
        "录入日期"
      ]
      import('@/vendor/Export2Excel').then(excel => {
        let list = this.tableData
        const data = this.formatJson([
          "sparePartsTypeName",
          "regionName",
          "trackingNum",
          "proportion",
          "totalFreight",
          "totalAmount",
          "logisticsCompanyName", "entryDate"], list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '运费占比存疑订单',
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.downloadLoading = false
        loading.close();
        this.dialogExportVisible = false
      })

    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {

        if (j === "proportion") {
          return v[j] + '%'
        }
        return v[j]
      }))
    },
    getData() {
      this.loading = true
      logisticsDoubt({type: this.type, sort: 'desc', column: "proportion", month: this.query.month}).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.filter(e => e.proportion >= 10)
          let that = this
          logisticsDoubt({type: this.type, sort: 'asc', column: "proportion", month: this.query.month}).then(res => {
            if (res.code === 0) {
              let list = res.data.filter(e => e.proportion <= 0.25)
              for (let i in list){
                that.tableData.push(list[i])
              }
              that.loading = false
            } else {
              that.$message.error(res.desc)
              that.loading = false
            }
          })
        } else {
          this.$message.error(res.desc)
          this.loading = false
        }
      })
    },
    sortChange(column) {//prop标签 => nickname
      if ('ascending' === column.order) {
        this.sort = "asc"
      } else {
        this.sort = "desc"
      }
      this.getData()

    },
    codeClick(row) {
      this.activeRow = row
      this.$refs.orderDetails.show()
    },
    followUpClick(record) {
      this.$confirm('确定要回访吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        insertLogisticsChecked({
          trackingNumber: record.trackingNum,
          logisticsCompanyId: record.logisticsCompanyId,
          addressId: record.addressId
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '处理成功!'
            });
            this.getData()
            this.$emit('followUpClick')
          }
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/statistics.scss";

.red {
  color: red;
}

.click {
  cursor: pointer;
  color: $main-color;
  text-decoration: underline;
}
</style>
